<template>
  <div
    v-if="
      planLimitShown ||
      shouldShowUpgradeButton ||
      isOnboardButtonShown ||
      showTrialBlock
    "
    class="plan-banner"
  >
    <div v-if="title" class="paragraph-s medium mb-3">{{ title }}</div>

    <div
      v-if="planLimitShown && !trialExpired"
      class="eg-progress-bar-container"
    >
      <eg-progress-bar
        :max="accountProvider.usage?.essaysUsage?.limit"
        :value="accountProvider.usage?.essaysUsage?.count"
        :label="$t('common.planLimit')"
      />
    </div>

    <plan-banner-trial
      v-if="showTrialBlock"
      :days-left="trialDaysLeft"
      :total-days="trialTotalDays"
      :is-expired="trialExpired"
    />

    <div class="d-flex flex-column flex-gap-1">
      <eg-button
        v-if="shouldShowUpgradeButton"
        type="primary"
        icon="stars"
        class="w-100"
        @click="upgradePlan"
      >
        {{ $t("account.upgradePlan") }}
      </eg-button>
      <eg-button
        v-if="isOnboardButtonShown"
        type="secondary"
        right-icon="arrow-right"
        class="w-100"
        @click="$emit('onShowOnboardBanner')"
      >
        {{ $t("dashboard.onboardYourSchool") }}
      </eg-button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import EgProgressBar from "@/components/global/eg/eg_progress_bar.vue";
import UpgradePlanModal from "@/components/global/modals/upgrade_plan_modal.vue";
import PlanBannerTrial from "./plan-banner-trial.vue";

export default defineComponent({
  name: "PlanBanner",
  components: { EgProgressBar, PlanBannerTrial },
  inject: ["accountProvider"],
  props: {
    title: { type: String, default: null },
    isOnboardButtonShown: { type: Boolean, default: false },
    planLimitShown: { type: Boolean, default: true },
    upgradeButtonShown: { type: Boolean, default: true },
  },
  computed: {
    trialDaysLeft() {
      return this.$store.getters?.trialEndsInDays;
    },
    trialTotalDays() {
      return this.$store.getters?.trialTotalDays || 7;
    },
    showTrialBlock() {
      return this.$store.getters.isTrial || this.$store.getters.isTrialExpired;
    },
    trialExpired() {
      return this.$store.getters.isTrialExpired;
    },
    isPremiumPlan() {
      return this.$store.state?.user?.plan === "premium";
    },
    showSubscriptionActions() {
      return this.accountProvider.showSubscriptionActions;
    },
    shouldShowUpgradeButton() {
      if (this.showTrialBlock) {
        return true;
      }
      return (
        this.upgradeButtonShown &&
        this.showSubscriptionActions &&
        !this.isPremiumPlan
      );
    },
  },
  methods: {
    upgradePlan() {
      this.$egModal.show("upgrade-plan-modal", {
        component: UpgradePlanModal,
        props: {
          currentPlan: this.accountProvider?.subscription?.plan,
        },
      });
    },
  },
});
</script>

<style scoped lang="scss">
.plan-banner {
  background-color: white;
  border-radius: var(--radius-rd-400);

  .eg-progress-bar-container {
    margin-bottom: 8px;
  }
}
</style>
